import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { QuoteItem } from '@/types'

interface QuoteStore {
  items: QuoteItem[]
  addItem: (item: QuoteItem) => void
  removeItem: (variantId: string) => void
  clearQuote: () => void
}

export const useQuoteStore = create<QuoteStore>()(
  persist(
    (set) => ({
      items: [],

      addItem: (item) =>
        set((state) => {
          const existing = state.items.find((i) => i.variantId === item.variantId)
          if (existing) return state
          return { items: [...state.items, item] }
        }),

      removeItem: (variantId) =>
        set((state) => ({
          items: state.items.filter((i) => i.variantId !== variantId),
        })),

      clearQuote: () => set({ items: [] }),
    }),
    { name: 'jm-quote' }
  )
)
